// extracted by mini-css-extract-plugin
module.exports = {"header":"MainNavigation_header__2lqQ1","logo":"MainNavigation_logo__1TgMx"};